export function labelToWeek(activeLabel: string) {
  const parts = activeLabel.split(" ") ?? [];
  if (parts.length <= 0) throw new Error("Invalid label");
  const week = parseInt(parts[1]);
  const year = parseInt(parts[2]);
  return { week, year };
}
